import { mapGetters } from 'vuex'
import { webUrl } from '@/lib/route'
import Platform from '@/plugin-platforms'

export default {
  computed: {
    ...mapGetters({
      user: 'user/get',
      individualUser: 'user/getIndividualUser',
      selectedDesigner: 'user/selectedDesigner'
    }),
    isLoggedIn () {
      return !!this.user
    },
    selectedDesigners () {
      return this.selectedDesigner
    },
    isSeller () {
      return this.user && this.user.is_contributor
    },
    isTeam () {
      return this.user && this.user.type === 'team'
    },
    cartItems () {
      return this.$store.getters['purchase/cartItems'].length || this.user.cart_collections_count || 0
    },
    hasPremiumSubscription () {
      const user = this.user
      return (
        user &&
        user.subscriptions.length
      )
    },
    hasLimitedSubscription () {
      return this.hasPremiumSubscription && this.user.subscriptions[0].plan_info.id !== 3
    },
    referralUrl () {
      if (process.client) {
        let router = this.$router.resolve({
          name: 'pricing',
          query: {
            referral_code: this.user.referral_code
          }
        })
        return window.location.origin + router.href
      }
    }
  },

  methods: {
    handleAuth () {
      if (this.isLoggedIn) {
        return true
      } else {
        this.$router.push({
          name: 'login'
        })
        return false
      }
    },
    onEditProfile () {
      let url = webUrl('profile')
      Platform.openURL(url)
    },
    onUpgrade () {
      let url = webUrl('upgrade')
      Platform.openURL(url)
    },
    onAddMember () {
      let url = webUrl('member')
      Platform.openURL(url)
    },
    onAddTeam () {
      let url = webUrl('team')
      Platform.openURL(url)
    },
    onLogout () {
      this.$store.dispatch('user/logout')
      this.$router.push({
        name: 'icons-slug'
      })
    }
  }
}
